import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'

import {catchError, finalize, map, shareReplay, tap} from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Usuario, Sucursales } from './interfaces/interfaces';
import { Router } from '@angular/router';
import { ApiService } from '../core/api/api.service';
//const Swal = require('sweetalert2');
@Injectable({
  providedIn: 'root'
})
export class AuthService {

   private userlogin!: Usuario;

  private _token: string = "";
  private  _ideUsuario: number = 0;
  private validatedToken = '';
  private tokenValidationRequest?: Observable<boolean>;

  constructor(
    private http: HttpClient,
    private api: ApiService,
    private router: Router) { }



  get loginUsuario(){

    return {...this.userlogin};
  }


  /* -------------------------------------------------------------------------- */
  /*                               INICIAR SESSION                              */
  /* -------------------------------------------------------------------------- */
  login(usuario: string, clave: string): Observable<{ rows: any[] }> {
    return this.api.post<{ rows: any[] }>('/users/login', {
      usuario,
      password: clave
    }).pipe(
      tap((resp) => this.setAuthenticatedUser(resp.rows))
    );
  }



  /* -------------------------------------------------------------------------- */
  /*                             OBTENER SUCURSALES                             */
  /* -------------------------------------------------------------------------- */
  cargarSucursales(_tipo, _item, _valor, _token){
    return this.api.post<{ rows: Sucursales[] }>('/users/login/branches');
  }


  /* -------------------------------------------------------------------------- */
  /*                              EDITAR SUCURSALES                             */
  /* -------------------------------------------------------------------------- */
  updateSucursal(_idUsuario, sucursal, _token) {
    return this.api.post('/users/branch/update', { sucursal });
  }

  cambiarClave(passwordActual: string, passwordNueva: string) {
    return this.api.post('/users/password/change', {
      passwordActual,
      passwordNueva
    });
  }

  obtenerSesionesActivas() {
    return this.api.post('/users/sessions/list');
  }

  revocarSesion(sessionId: number) {
    return this.api.post('/users/sessions/revoke', { sessionId });
  }

  revocarOtrasSesiones() {
    return this.api.post('/users/sessions/revoke-others');
  }

  getIpAdress(){

    const url = `https://geolocation-db.com/json/`;
          
    return this.http.get<Sucursales>(url).pipe(
        map(resp=> resp),
        catchError(err => of(err)))
  }

  validarIpUsuario(sucursal, token): Observable<{
    operacion: boolean;
    mensaje: string;
    ip: string;
  }> {
    return this.api.postWithToken(
      '/security/ip-access/validate',
      { idSucursal: Number(sucursal) },
      token
    );
  }

  


 logoutPorSesion(){

  /*Swal.fire({
    title: 'Su sesión ha expirado',
    text: "Por motivos de seguridad inicie sesión nuevamente!",
    icon: 'warning',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Salir',
    closeOnConfirm: false, //It does close the popup when I click on close button
    closeOnCancel: false,
    allowOutsideClick: false

  }).then((result) => {

    if (result.isConfirmed) {
      this.router.navigateByUrl('/login');

    }
  })*/
}

  logoutUser(){

    this.logout();
    
    /*Swal.fire({
      title: 'Su sesión ha expirado',
      text: "Por motivos de seguridad inicie sesión nuevamente!",
      icon: 'warning',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Salir',
      closeOnConfirm: false, //It does close the popup when I click on close button
      closeOnCancel: false,
      allowOutsideClick: false

    }).then((result) => {

      if (result.isConfirmed) {
        this.router.navigateByUrl('/login');

      }
    })*/
  }

 
  //VALIDAR TOKEN DE INICIO
  validarToken(): Observable<boolean> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
      this.clearAuthenticatedUser();
      return of(false);
    }

    if (
      this.validatedToken === token &&
      this.userlogin?.token === token &&
      Number(this.userlogin?.estado) === 1
    ) {
      return of(true);
    }

    if (this.tokenValidationRequest) {
      return this.tokenValidationRequest;
    }

    this.tokenValidationRequest = this.api.post<{ rows: any[] }>('/users/validate-token').pipe(
      map((resp) => {
        this.setAuthenticatedUser(resp.rows);
        const valid = resp.rows.length > 0;
        if (!valid) {
          this.clearSession();
        }
        return valid;
      }),
      catchError(() => {
        this.clearSession();
        return of(false);
      }),
      finalize(() => {
        this.tokenValidationRequest = undefined;
      }),
      shareReplay({ bufferSize: 1, refCount: false })
    );

    return this.tokenValidationRequest;
  }

  validarEstadoUsuario() : Observable<boolean> {
    return this.validarToken().pipe(
      map((valid) => valid && Number(this.userlogin?.estado) === 1)
    );
  }

   

  //CERRAR SESION
  logout(){
    this.clearSession();
    void this.router.navigateByUrl('/login');
  }

  private setAuthenticatedUser(rows: any[] = []): void {
    const user = rows[0];
    if (!user) {
      this.userlogin = {} as Usuario;
      return;
    }

    this.userlogin = {
      nombre: user.nombre,
      email: user.usuario,
      token: user.llave_secreta_usuario,
      foto: user.foto,
      perfil: user.perfil,
      permisos: Array.isArray(user.permisos) ? user.permisos : [],
      sucursal: user.FK_COD_SURCUSU,
      idUsuario: user.id,
      nombreSucursal: user.DIR_SURC,
      secuencial: user.secuencial,
      estado: user.estado,
      analisis: user.analisis_cefa,
      citaPrevia: user.cita_previa,
      profileName: user.profile_name,
    };
    this.validatedToken = String(user.llave_secreta_usuario || '');
  }

  private clearAuthenticatedUser(): void {
    this.userlogin = {} as Usuario;
    this.validatedToken = '';
  }

  private clearSession(): void {
    localStorage.removeItem('token');
    this.clearAuthenticatedUser();
  }

  hasPermission(permissionCode: string): boolean {
    if (!permissionCode) return false;
    const permisos = this.userlogin?.permisos || [];
    return permisos.includes(permissionCode);
  }

  hasAnyPermission(permissionCodes: string[] = []): boolean {
    if (!permissionCodes.length) return true;
    const permisos = this.userlogin?.permisos || [];
    return permissionCodes.some((code) => permisos.includes(code));
  }








}
